<template>
  <el-dialog :visible.sync="showDialog" width="520px" height="530px" class="fixed-height-dialog" @close="handleDialogClose">
    <div slot="title" class="remote-title">
      {{this.$t("remote_create_room")}}
    </div>
  <div class="remote-play-container">

    <!-- 标签页切换 -->
    <div class="tab-header">
      <button
        class="tab-button"
        :class="{ active: activeTab === 'create' }"
        @click="activeTab = 'create'">{{this.$t("remote_create_room")}}</button>
      <button
        class="tab-button"
        :class="{ active: activeTab === 'join' }"
        @click="activeTab = 'join'">{{this.$t("remote_join_room")}}</button>
    </div>
    <div class="mira-form-divider"></div>
    <!-- 创建房间内容 -->
    <div v-if="activeTab === 'create'" class="tab-content create-room">
      <div class="form-group">
        <div style="display: flex; align-items: center; width: 100%;">
          <label style="white-space: nowrap;">{{this.$t("remote_room_name")}}</label>
          <el-input
            v-model="createForm.roomName"
            :placeholder="this.$t('remote_need_room_name')"
            maxlength="15"
          ></el-input>
        </div>
        <p class="hint-text">
          <img src="@/assets/remote/tip.png" class="hint-icon">{{this.$t("activity_remote_mode_remote_main_create_room_name_rule")}}
        </p>
      </div>

      <div class="form-group">
        <div style="display: flex; align-items: center; width: 100%;">
        <label>{{this.$t("remote_room_role")}}</label>
        <el-select v-model="createForm.userRole" >
          <el-option :label="this.$t('remote_room_role_recipient')" value="2"></el-option>
          <el-option :label="this.$t('remote_room_role_controller')" value="1"></el-option>
        </el-select>
        </div>
      </div>

      <div class="form-group">
        <div style="display: flex; align-items: center; width: 100%;">
        <label style="min-width: 180px">{{this.$t("remote_room_time_limit")}} {{createForm.duration}}min</label>
        </div>
      </div>

      <div class="form-actions">
        <button class="submit-button" @click="createRoom">{{this.$t("remote_create_room_button")}}</button>
      </div>
    </div>

    <!-- 加入房间内容 -->
    <div v-if="activeTab === 'join'" class="tab-content join-room">
      <div class="form-group">
        <div style="display: flex; align-items: center; width: 100%;">
          <label>{{this.$t("remote_room_code")}}</label>
          <el-input v-model="joinForm.roomId":placeholder="this.$t('remote_need_room_code')">
            <template #append>
              <el-button @click="searchRoom" class="search-button">
                <img src="@/assets/remote/search.png" class="search-icon">
              </el-button>
            </template>
          </el-input>
        </div>
      </div>

      <!--查询结果-开始-->

      <div class="search-results" v-if="this.isShowSeachResult">
        <div class="result-item">
          <span class="result-label">{{this.$t("remote_room_code")}}</span>
          <span class="result-value">{{this.searchResultForm.roomId}}</span>
        </div>
        <div class="result-item">
          <span class="result-label">{{this.$t("remote_room_time_limit")}}</span>
          <span class="result-value">{{this.searchResultForm.duration}}min</span>
        </div>
        <div class="result-item">
          <span class="result-label">{{this.$t("remote_room_person_has_in_room")}}</span>
          <span class="result-value">({{this.searchResultForm.onLine}}/2)</span>
        </div>
        <div class="result-item">
          <span class="result-label">{{this.$t("remote_room_role")}}</span>
          <span class="result-value">{{this.searchResultForm.userRoleView}}</span>
        </div>
        <div class="form-actions">
          <button class="submit-button" @click="joinRoom">{{this.$t("remote_join_room_button")}}</button>
        </div>
      </div>

      <div class="search-results" v-else>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
          <span class="result-label"></span>
          <span class="result-value"></span>
        </div>
        <div class="result-item">
        </div>
        <div class="form-actions">

        </div>
      </div>

      <!--查询结果-结束-->
    </div>
  </div>
  </el-dialog>
</template>

<script>
import * as bridgeApi from "@/api/platform/bridge";
import * as cache from "@/utils/cache";
import {appNewBridge, getMagpieBridgeBean, userIsOnline} from "../../../api/platform/bridge";

export default {
  name: 'RemotePlay',

  data() {
    return {
      activeTab: 'create', // 当前激活的标签页
      //设备类型 手机（远程互动，控制方可无设备，使用手机进行手动控制）
      DEVICE_TYPE_PHONE: -1,
      //设备类型 99= 外部设备未知类型
      DEVICE_TYPE_EXTRA: 99,
      //设备类型 0= 所有设备，不区分设备（或者标识未选择任何类型的设备）
      DEVICE_TYPE_ALL: 0,
      //设备类型 1= OSR2
      DEVICE_TYPE_OSR2: 1,
      //设备类型 2= SR6
      DEVICE_TYPE_SR6: 2,
      //设备类型 3= 摇杆
      DEVICE_TYPE_MAGIC_D: 3,
      isShowSeachResult: false,
      showDialog: false, // 初始设为false
      createForm: {
        roomId: '',//房间ID
        roomName: '',//房间名称
        userRole: '2',//角色
        duration: '10',//时长
      },
      searchResultForm: {
        code: '',//房间ID
        roomId: '',//房间ID
        userRole: '',//角色
        userRoleView: '',//角色
        onLine:0,//在线人数
        duration: '10',//时长
      },
      joinForm: {
        roomId: '',//房间ID
        type: '',//角色
      },
      deviceType: 2, //cache.getDeviceType(),
    }
  },
  methods: {
    handleDialogClose() {
      // 对话框关闭时的处理
      this.showDialog = false;
    },
    createRoom() {
      if (!this.createForm.roomName) {
        this.$message({type: "error", message: this.$t('remote_need_room_name')});
        return;
      }

      const pk_user = cache.getUserInfo().pk;
      bridgeApi.appNewBridge(pk_user).then(result => {
        if (result.data === null){
          this.$message({type: "error", message: this.$t('activity_remote_mode_remote_main_create_room_not_allowed')});
        } else {
          this.createForm.roomId = result.data.code;
          this.joinForm.type = this.createForm.userRole;
          bridgeApi.userIsOnline(this.createForm.userRole, result.data).then(result2 => {
            appGlobal.setData(pk_user, {
              "roomIdt": this.createForm.roomId,
              "isCreatt": "Y",
              "typet": this.createForm.userRole
            });
            this.toRoomPage(true);
          }).catch(error => {
          })
        }
      }).catch(error => {
      })
    },
    searchRoom() {
      if (!this.joinForm.roomId) {
        this.$message({type: "error", message: this.$t('remote_need_room_code')});
        return;
      }
      this.isShowSeachResult = false;
      bridgeApi.getMagpieBridgeBean(this.joinForm.roomId).then(result => {
        if (result.data) {
          this.searchResultForm.duration = 10;
          this.searchResultForm.roomId = this.joinForm.roomId;
          this.searchResultForm.code = this.joinForm.roomId;
          console.log(result.data);
          if (result.data.sendState == 1 && result.data.receiveState == 2){
            this.searchResultForm.userRole = 2;
            this.searchResultForm.onLine = 1;
            this.searchResultForm.userRoleView = this.$t('remote_room_role_recipient');
          }
          if (result.data.sendState == 2 && result.data.receiveState == 1){
            this.searchResultForm.userRole = 1;
            this.searchResultForm.onLine = 1;
            this.searchResultForm.userRoleView = this.$t('remote_room_role_controller');
          }
          if (result.data.sendState == 2 && result.data.receiveState == 2){
            this.searchResultForm.onLine = 2;
          }
          this.isShowSeachResult = true;
        } else {
          this.$message({type: "error", message: this.$t('remote_join_room_query_nothing')});
          return;
        }
      }).catch(error => {
      })
      // API调用代码
    },
    joinRoom() {
      if (!this.joinForm.roomId) {
        this.$message({type: "error", message: this.$t('remote_need_room_code')});
        return;
      }
      if (!this.searchResultForm.userRole) {
        this.$message({type: "error", message: this.$t('remote_join_room_query_nothing')});
        return;
      }
      if (this.searchResultForm.onLine == 2) {
        this.$message({type: "error", message: this.$t('remote_join_room_is_full')});
        return;
      }
      //使用与创建房间者相反的角色
      if(this.searchResultForm.userRole == 2){
        this.joinForm.type = 1;
      }else {
        this.joinForm.type = 2;
      }
      bridgeApi.userIsOnline(this.joinForm.type, this.searchResultForm).then(result2 => {
        const user = appGlobal.getData(cache.getUserInfo().pk);
        if (user && user.roomIdt === this.joinForm.roomId) {
          // 如果roomId相同，直接跳转页面，不重复设置
        } else {
          appGlobal.setData(cache.getUserInfo().pk, {
            "roomIdt": this.joinForm.roomId,
            "isCreatt": "N",
            "typet": this.createForm.userRole
          });
        }

        this.toRoomPage(false);
      }).catch(error => {
      })
    },
    //页面跳转
    toRoomPage(isCreate) {
      this.$router.push({
        path: "/room",  // 使用路由名称
        query: {
          roomId: this.joinForm.roomId ? this.joinForm.roomId : this.createForm.roomId,
          isCreate: isCreate,
          userRole: this.joinForm.type,
        },
      });
    },
  },
  mounted() {
    this.showDialog = true;
  },
  created: function () {
    this.showDialog = true;
  }
}
</script>

<style scoped>
 .remote-title {
   vertical-align: middle;
   height: 35px;
   line-height: 35px;
   padding-left: 30px;
   font-family: PingFangSC-Semibold;
   font-size: 16px;
   color: #333333;
   letter-spacing: 0;
   font-weight: 600;
 }
 .fixed-height-dialog {
   height: 530px !important;
 }
.remote-play-container {
  width: 450px;
  height: 100%;
  padding-left: 30px;
  padding-top: 20px;
  border-radius: 8px;

}
 /* 分隔线 */
 .mira-form-divider {
   position: relative;
   margin: 0 ;
   color: #D8D8D8;
 }

 .mira-form-divider:before,
 .mira-form-divider:after {
   content: "";
   position: absolute;
   top: 0px;
   width: 100%;
   height: 1px;
   background-color: #eee;
 }

 .mira-form-divider:before {
   left: 0;
 }

 .mira-form-divider:after {
   right: 0;
 }
.tab-header {
  display: inline-flex; /* 改为 inline-flex 以便实现靠左对齐 */
  margin-top: 0px;
  margin-bottom: 0px;
  border-bottom: 1px solid #D8D8D8;
}

.tab-button {
  flex: 1;
  padding: 8px 20px;
  background-color: white; /* 默认背景色 */
  border: 1px solid #A2A2A2; /* 统一边框 */
  border-right: none; /* 去掉右侧边框，避免重复 */
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.tab-button:last-child {
  border-right: 1px solid #A2A2A2; /* 最后一个按钮保留右边框 */
}

.tab-button.active {
  background-color: #AA81FF; /* 浅紫色背景 */
  color: #FFFFFF;
  font-weight: bold;
}

.tab-content {
  padding: 20px 15px;
}
 .join-room{
  height: 100%;
 }
 .form-group {
   width: calc(100% - 60px);
   margin-bottom: 15px;
   display: flex;
   flex-direction: column; /* 改为纵向排列 */
   gap: 1px; /* 控制上下间距 */
 }

 .form-group label {
   flex: 0 0 90px;
   font-size: 14px;
   color: #333;
   text-align: left;
 }

.form-group input,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
 .hint-text {
   font-size: 12px;
   color: #888;
   display: flex;
   align-items: center;
   padding-left: 100px; /* 与 label 宽度一致，视觉对齐 */
   font-weight: 400;
 }

 .hint-icon {
   width: 14px;
   height: 14px;
   margin-right: 3px;
 }
 .form-actions {
   display: flex;
   justify-content: center; /* 居中对齐 */
   align-items: center;
   margin-top: 40px; /* 向上靠拢 */
 }

.width-hint {
  font-size: 12px;
  color: #999;
}

.submit-button {
  width: 120px;
  padding: 10px 0;
  background-color: #AA81FF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #7200D6;
}

/* 下拉箭头样式 */
select {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 14px;
  padding-right: 30px;
}
 .search-button {
   background-color: #AA81FF !important;
   border-color: #AA81FF !important;
   padding: 11px 15px;
   align-items: center; /* This will vertically center the icon */
   justify-content: center; /* This will horizontally center the icon */
 }

 .search-button:hover {
   background-color: #7200D6 !important;
   border-color: #7200D6 !important;
 }

 .search-icon {
   width: 18px;
   height: 18px;
   filter: brightness(0) invert(1); /* Makes the icon white */
   display: block; /* Ensures the image behaves correctly for alignment */
   margin-top: -2px; /* Optional: Fine-tune vertical position if needed */
 }
 .search-results {
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   margin: 20px 0;
 }

 .result-item {
   display: flex;
   align-items: center;
   justify-content: center;
   width: 100%;
   margin-bottom: 10px;
 }

 .result-label {
   margin-right: 10px;
   color: #333;
   text-align: right;
   min-width: 100px;
   font-size: 14px;
 }

 .result-value {
   color: #666;
   text-align: left;
   min-width: 100px;
   font-size: 14px;
 }
</style>



// WEBPACK FOOTER //
// src/pages/tcode/remote/remote.vue